import PuneToMumbai from "../images/services/Pune-to-Mumbai.jpg";
import MumbaiToPune from "../images/services/Mumbai-to-Pune.jpg";
import PunetoMumbaiAirport from "../images/services/Pune-to-Mumbai-Airport.jpg";
import MumbaiAirporttoPune from "../images/services/Mumbai-Airport-to-Pune.jpg";
import PunetoShirdi from "../images/services/Pune-to-Shirdi.jpg";
import Punetooutstation from "../images/services/Pune-to-outstation.jpg";
import Mumbaitooutstation from "../images/services/Mumbai-to-outstation.jpg";
import PuneToNasik from "../images/services/Pune-to-Nasik.jpg";
import PuneToMahableshwar from "../images/services/Pune-to-Mahableshwar.jpg";
import PuneToKolhapur from "../images/services/Pune-to-Kolhapur.jpg";
import PunetoLonavala from "../images/services/Pune-to-Lonavala.jpg";

function Banner() {
  const servicesData = [
    {
      id: 1,
      title: "Pune to Mumbai",
      description:
        "Looking for a comfortable and reliable mode of transportation between Pune and Mumbai? Consider My Dear Cab. Let's chat on WhatsApp!",
      image: PuneToMumbai,
      actionType: "whatsapp",
      actionText: "ENQUIRE NOW",
      actionLink:
        "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
    },
    {
      id: 2,
      title: "Mumbai to Pune",
      description:
        "If you're planning a trip from Mumbai to Pune and need a dependable MyDearCab option, look no further than My Dear Cab. Chat with us on WhatsApp!",
      image: MumbaiToPune,
      actionType: "whatsapp",
      actionText: "ENQUIRE NOW",
      actionLink:
        "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
    },
    {
      id: 3,
      title: "Pune to Mumbai Airport",
      description:
        "Are you looking for a cab from Pune to Mumbai Airport? My Dear Cab Pune to Mumbai Airport taxi service is the perfect choice for you. Chat with us on WhatsApp!",
      image: PunetoMumbaiAirport,
      actionType: "whatsapp",
      actionText: "ENQUIRE NOW",
      actionLink:
        "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
    },
    {
      id: 4,
      title: "Mumbai Airport to Pune",
      description:
        "Need a reliable and hassle-free taxi service from Mumbai Airport to Pune? My Dear Cab Mumbai Airport to Pune taxi service is the perfect solution for you.",
      image: MumbaiAirporttoPune,
      actionType: "whatsapp",
      actionText: "ENQUIRE NOW",
      actionLink:
        "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
    },
    {
      id: 5,
      title: "Pune to Shirdi",
      description:
        "Need a reliable and hassle-free MyDearCab service from Pune to Shirdi cabs? My Dear Cab Pune to Shirdi taxi service is the perfect solution for you. Let's chat on WhatsApp!",
      image: PunetoShirdi,
      actionType: "whatsapp",
      actionText: "ENQUIRE NOW",
      actionLink:
        "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
    },
    {
      id: 6,
      title: "Pune to Lonavala",
      description:
        "Need a reliable and hassle-free MyDearCab service from Pune to Lonavala cabs? My Dear Cab Pune to Lonavala taxi service is the perfect solution for you.",
      image: PunetoLonavala,
      actionType: "whatsapp",
      actionText: "ENQUIRE NOW",
      actionLink:
        "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
    },
    {
      id: 7,
      title: "Mumbai to Shirdi",
      description:
        "Need a reliable and hassle-free MyDearCab service from Mumbai to Shirdi cabs? My Dear Cab Mumbai to Shirdi taxi service is the perfect solution for you. Let's chat on WhatsApp!",
      image: PunetoShirdi,
      actionType: "whatsapp",
      actionText: "ENQUIRE NOW",
      actionLink:
        "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
    },
    {
      id: 8,
      title: "Pune to Outstation",
      description:
        "Need a reliable and hassle-free MyDearCab service from Pune to outstation cabs? My Dear Cab Pune to outstation taxi service is the perfect solution for you. Let's chat on WhatsApp!",
      image: Punetooutstation,
      actionType: "whatsapp",
      actionText: "ENQUIRE NOW",
      actionLink:
        "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
    },
    {
      id: 9,
      title: "Mumbai to Outstation",
      description:
        "Need a reliable and hassle-free MyDearCab service from Mumbai to outstation cabs? My Dear Cab Mumbai to outstation taxi service is the perfect solution for you. Let's chat on WhatsApp!",
      image: Mumbaitooutstation,
      actionType: "whatsapp",
      actionText: "ENQUIRE NOW",
      actionLink:
        "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
    },
    {
      id: 10,
      title: "Pune to Nasik",
      description:
        "Need a reliable and hassle-free MyDearCab service from Pune to Nasik cabs? My Dear Cab Pune to Nasik taxi service is the perfect solution for you. Let's chat on WhatsApp!",
      image: PuneToNasik,
      actionType: "whatsapp",
      actionText: "ENQUIRE NOW",
      actionLink:
        "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
    },
    {
      id: 11,
      title: "Pune to Mahableshwar",
      description:
        "Need a reliable and hassle-free MyDearCab service from Pune to Mahableshwar cabs? My Dear Cab Pune to Mahableshwar taxi service is the perfect solution for you. Let's chat on WhatsApp!",
      image: PuneToMahableshwar,
      actionType: "whatsapp",
      actionText: "ENQUIRE NOW",
      actionLink:
        "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
    },
    {
      id: 12,
      title: "Pune to Kolhapur",
      description:
        "Need a reliable and hassle-free MyDearCab service from Pune to Kolhapur cabs? My Dear Cab Pune to Kolhapur taxi service is the perfect solution for you. Let's chat on WhatsApp!",
      image: PuneToKolhapur,
      actionType: "whatsapp",
      actionText: "ENQUIRE NOW",
      actionLink:
        "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab",
    },
  ];

  const handleAction = (actionLink) => {
    window.open(actionLink, "_blank");
  };

  return (
    <>
      <section className="services-section">
        <div className="container">
          {/* Header Section */}
          <div className="services-header">
            <div className="services-header__left">
              <h2 className="services-subtitle">Trusted Cab Rental Company</h2>
              <h3 className="services-title">Our Services</h3>
            </div>
            <div className="services-header__right">
              <button
                className="enquire-btn"
                onClick={() =>
                  handleAction(
                    "https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab"
                  )
                }
              >
                <i className="fas fa-arrow-right"></i>
                Enquire Now
              </button>
            </div>
          </div>

          {/* Services Grid */}
          <div className="services-grid">
            {servicesData.map((service, index) => (
              <div key={service.id} className="service-card">
                <div className="service-image">
                  <img
                    src={service.image}
                    alt={service.title}
                    loading={index < 3 ? "eager" : "lazy"}
                  />
                </div>
                <div className="service-content">
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-description">{service.description}</p>
                  <button
                    className={`service-btn ${
                      service.actionType === "whatsapp"
                        ? "whatsapp-btn"
                        : "phone-btn"
                    }`}
                    onClick={() => handleAction(service.actionLink)}
                  >
                    {service.actionType === "whatsapp" ? (
                      <i className="fab fa-whatsapp"></i>
                    ) : (
                      <i className="fas fa-phone-alt"></i>
                    )}
                    {service.actionText}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Banner;
